module.exports = __webpack_public_path__ + "static/img/avatar.c4b0d8fc.gif";